export default "__VITE_ASSET__BZNVPKtZ__"